import { useEffect, useState } from 'react';
import { whenIdle } from 'src_common/utils/Idle';

const FALLBACK_TIMEOUT_MS = 5000;

export const useDeferUntilIdle = (): boolean => {
    const [isIdle, setIsIdle] = useState(false);

    useEffect(() => {
        const unsubscribe = whenIdle(() => setIsIdle(true));
        const timeoutId = setTimeout(() => setIsIdle(true), FALLBACK_TIMEOUT_MS);

        return (): void => {
            unsubscribe();
            clearTimeout(timeoutId);
        };
    }, []);

    return isIdle;
};
